(function ($) {
    $(function () {

        // Function to open the burger menu
        //---------------------------------------------------
        const burgerBtn = $("#header .btn-burger-container");

        burgerBtn.on("click", function (e) {
            e.preventDefault();

            setCurrentHeaderHeightVar();
            $("body, html").toggleClass("menu-open");

            // Close any open dropdowns when the burger menu closes.
            if (!$("body").hasClass("menu-open")) {
                closeAllDropdowns();
            }
        });


        // Dropdown toggles for parent navigation items
        //---------------------------------------------------
        const navToggles = document.querySelectorAll(
            ".navigation .dropdown > .dropdown-toggle"
        );

        function getDropdownMenu(toggle) {
            const menu = toggle.nextElementSibling;

            if (!menu || !menu.classList.contains("dropdown-menu")) {
                return null;
            }

            return menu;
        }

        function closeDropdown(toggle) {
            const menu = getDropdownMenu(toggle);

            if (!menu) {
                return;
            }

            menu.classList.remove("open-menu");
            toggle.setAttribute("aria-expanded", "false");
        }

        function openDropdown(toggle) {
            const menu = getDropdownMenu(toggle);

            if (!menu) {
                return;
            }

            menu.classList.add("open-menu");
            toggle.setAttribute("aria-expanded", "true");
        }

        function closeAllDropdowns(exceptToggle = null) {
            navToggles.forEach(function (toggle) {
                if (toggle !== exceptToggle) {
                    closeDropdown(toggle);
                }
            });
        }

        navToggles.forEach(function (toggle) {
            const menu = getDropdownMenu(toggle);

            if (!menu) {
                return;
            }

            toggle.setAttribute("aria-expanded", "false");

            toggle.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = menu.classList.contains("open-menu");

                closeAllDropdowns();

                if (!isOpen) {
                    openDropdown(toggle);
                }
            });

            toggle.addEventListener("keydown", function (e) {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggle.click();
                }
            });
        });


        // Close desktop dropdown when the cursor leaves the parent item
        //---------------------------------------------------
        document
            .querySelectorAll("#header .main-menu > .dropdown")
            .forEach(function (dropdown) {
                dropdown.addEventListener("mouseleave", function () {
                    const toggle = dropdown.querySelector(
                        ":scope > .dropdown-toggle"
                    );

                    if (toggle) {
                        closeDropdown(toggle);
                    }
                });
            });


        // Close dropdown when a child link is clicked
        //---------------------------------------------------
        document
            document.querySelectorAll (
                ".navigation .dropdown-menu .dropdown-item"
            )
            .forEach(function (link) {
                link.addEventListener("click", function () {
                    closeAllDropdowns();

                    // Also close the mobile burger menu.
                    $("body, html").removeClass("menu-open");
                });
            });


        // Close the mobile menu when a normal top-level link is clicked
        //---------------------------------------------------
        document
            document.querySelectorAll(
                ".mobile-menu > .nav-item:not(.dropdown) > a"
            )
            .forEach(function (link) {
                link.addEventListener("click", function () {
                    closeAllDropdowns();
                    $("body, html").removeClass("menu-open");
                });
            });


        // Close dropdowns when clicking outside the navigation
        //---------------------------------------------------
        document.addEventListener("click", function (e) {
            if (!e.target.closest(".navigation .dropdown")) {
                closeAllDropdowns();
            }
        });


        // Close dropdowns using the Escape key
        //---------------------------------------------------
        document.addEventListener("keydown", function (e) {
            if (e.key !== "Escape") {
                return;
            }

            const openMenu = document.querySelector(
                ".navigation .dropdown-menu.open-menu"
            );

            if (!openMenu) {
                return;
            }

            const toggle = openMenu.previousElementSibling;

            closeAllDropdowns();

            if (toggle) {
                toggle.focus();
            }
        });


        // Close menus when the browser width changes
        //---------------------------------------------------
        let windowWidth = $(window).width();

        $(window).on("resize", function () {
            const newWindowWidth = $(window).width();

            if (newWindowWidth !== windowWidth) {
                $("body, html").removeClass("menu-open");
                closeAllDropdowns();

                windowWidth = newWindowWidth;
            }
        });


        // Give the main element the height of the fixed header
        //---------------------------------------------------
        let mainResizeTimer;

        function setHeaderHeightVar() {
            const header = $("#header");

            if (!header.length) {
                return;
            }

            const body = $("body");
            const wasScrolled = body.hasClass("scrolled");

            // Temporarily remove the scrolled class so the full header
            // height can be measured.
            if (wasScrolled) {
                body.removeClass("scrolled");
            }

            const headerHeight = header.outerHeight();

            document.documentElement.style.setProperty(
                "--header-height",
                headerHeight + "px"
            );

            if (wasScrolled) {
                body.addClass("scrolled");
            }

            setCurrentHeaderHeightVar();
        }

        function setCurrentHeaderHeightVar() {
            const header = $("#header");

            if (!header.length) {
                return;
            }

            document.documentElement.style.setProperty(
                "--header-height-current",
                header.outerHeight() + "px"
            );
        }

        // Run once before the scrolled class is added.
        setHeaderHeightVar();

        // Run again when fonts, images and other assets have loaded.
        window.addEventListener("load", setHeaderHeightVar);

        window.addEventListener("resize", function () {
            clearTimeout(mainResizeTimer);

            mainResizeTimer = setTimeout(function () {
                setHeaderHeightVar();
            }, 100);
        });


        // Set up the dynamic border on desktop menu items
        //---------------------------------------------------
        let navResizeTimer;

        const headerEl = document.querySelector("#header");
        const navItems = document.querySelectorAll(
            "#header .main-menu.navigation > li"
        );

        function measureNavOffsets(targetScrolled) {
            if (!headerEl || !navItems.length) {
                return [];
            }

            const root = document.documentElement;
            const body = document.body;
            const current = body.classList.contains("scrolled");
            const mustToggle = targetScrolled !== current;

            root.classList.add("nav-measuring");

            if (mustToggle) {
                body.classList.toggle("scrolled", targetScrolled);
            }

            const headerRect = headerEl.getBoundingClientRect();

            const offsets = Array.from(navItems, function (item) {
                const itemRect = item.getBoundingClientRect();

                return Math.round(
                    headerRect.bottom - itemRect.bottom
                ) + 1;
            });

            if (mustToggle) {
                body.classList.toggle("scrolled", current);
            }

            // Force the restored layout to be committed before transitions
            // are enabled again.
            void headerEl.offsetWidth;

            root.classList.remove("nav-measuring");

            return offsets;
        }

        function applyNavOffsets(offsets) {
            navItems.forEach(function (item, index) {
                if (typeof offsets[index] === "undefined") {
                    return;
                }

                item.style.setProperty(
                    "--nav-underline-bottom",
                    "-" + offsets[index] + "px"
                );
            });
        }

        function setNavUnderlineInstant() {
            if (!headerEl || !navItems.length) {
                return;
            }

            const current = document.body.classList.contains("scrolled");
            const offsets = measureNavOffsets(current);
            const root = document.documentElement;

            root.classList.add("nav-measuring");

            applyNavOffsets(offsets);

            void headerEl.offsetWidth;

            root.classList.remove("nav-measuring");
        }

        setNavUnderlineInstant();

        window.addEventListener("load", setNavUnderlineInstant);

        window.addEventListener("resize", function () {
            clearTimeout(navResizeTimer);

            navResizeTimer = setTimeout(function () {
                setNavUnderlineInstant();
            }, 100);
        });


        // Add the scrolled class when the page is scrolled
        //---------------------------------------------------
        function toggleScrolledClass() {
            const isScrolled = $(window).scrollTop() >= 100;
            const body = $("body");

            if (isScrolled && !body.hasClass("scrolled")) {
                const target = measureNavOffsets(true);

                body.addClass("scrolled");

                applyNavOffsets(target);
                setCurrentHeaderHeightVar();
            }

            if (!isScrolled && body.hasClass("scrolled")) {
                const target = measureNavOffsets(false);

                body.removeClass("scrolled");

                applyNavOffsets(target);
                setCurrentHeaderHeightVar();
            }
        }

        toggleScrolledClass();

        $(window).on("scroll", toggleScrolledClass);

    });
})(jQuery);
